<!--header section-->
<section>
    <div class="container-fluid breadcrumb_comp">
        <div class="d-flex justify-content-between align-items-center">
            <div class=" ">
                <div class="custom-breadcrumb border-none">
                    <nav style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='currentColor'/%3E%3C/svg%3E&#34;);" aria-label="breadcrumb">
                        <ol class="breadcrumb mt-3">
                          <ng-content></ng-content>
                        </ol>
                      </nav>
                </div>
            </div>
            <div class=" ">
                <div class="custom-breadcrumb breadcrumb_none">
                    <nav aria-label="breadcrumb ">
                        <ol class="breadcrumb justify-content-between align-items-center m-0">
                            <div class="">
                                <span class="me-2"> {{adminProfile.firstName+ ' '+ adminProfile.lastName}} </span>
                                <img id="profile-image" class="rounded-circle" type="button"  data- 
                                bs-toggle="dropdown" aria-expanded="false"
                             (click)="showdropdown()"  [src]="adminProfile?.profilePic? adminProfile?.profilePic : 'assets/images/male 02.svg'" width="60px" height="60px">
                            </div>
                            <!-- <ng-content></ng-content> -->
                        </ol>
                    </nav>
                    <div class="dropdown " *ngIf="isShow">
                        <ul class="dropdown-menu border-0" [ngClass]="isShow ? 'show':'hide'">
                          <li><a class="dropdown-item" (click)="showProfile()" >
                            <img src="assets/images/user-3-fill.svg">
                            Profile</a></li>
                          <hr class="my-1">
                          <li><a class="dropdown-item"  (click)="openLogoutDialog()">
                              <img src="assets/images/logout-box-r-line.svg">
                              Logout</a></li>
                        </ul>
                      </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!--header section-->